import { useParams } from 'react-router-dom'
import { ReserveDetailSection } from '@/components/dashboard/ReserveDetailSection'

/// Wider than VaultDetailPage's 900px: this page carries a sticky action rail beside its content,
/// and at 900 the two columns fight each other.
export function ReserveDetailPage() {
  const { asset } = useParams()
  return (
    <div style={{ maxWidth: 1240, margin: '0 auto', padding: '24px' }}>
      <ReserveDetailSection asset={asset} />
    </div>
  )
}
